<template>
  <svg
    id="icon-magnifying-glass"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 27 28"
    :fill="fill"
  >
    <path
      fill-rule="evenodd"
      d="M18.162 10.553a7.417 7.417 0 1 1-14.834 0 7.417 7.417 0 0 1 14.834 0Zm-2.19 9.012a10.37 10.37 0 0 1-5.227 1.405C4.992 20.97.328 16.306.328 10.553S4.992.136 10.745.136 21.162 4.8 21.162 10.553c0 2.76-1.074 5.27-2.826 7.133l8.056 8.056-2.121 2.121-8.299-8.298Z"
      clip-rule="evenodd"
    />
  </svg>
</template>

<script>
import { iconPropsFunc } from "./mixins/icons";

export default {
  name: "IconMagnifyingGlass",
  mixins: [iconPropsFunc()],
};
</script>

<style lang="scss" scoped></style>
